// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__D0akl","thankyou1":"Thankyou_thankyou1__KI-dp","thankyou123":"Thankyou_thankyou123__tVhuy"};